import { initializeApp } from 'firebase/app';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { getAuth, Auth } from 'firebase/auth';
import { getDatabase, Database } from 'firebase/database';
import { getMessaging, Messaging } from 'firebase/messaging';
import { Config } from '../../Config/Config';

export const FirebaseApp = initializeApp(Config.firebase);
export const FirebaseAnalytics: Analytics = getAnalytics(FirebaseApp);

export const FirebaseAuth: Auth = getAuth(FirebaseApp);

export const FirebaseDatabase: Database = getDatabase(FirebaseApp);

// getMessaging() throws synchronously AND leaks an unhandled rejection in browsers
// without push support (no service worker / Push API — e.g. older Safari, test
// environments). Feature-check first so the whole bundle doesn't die at import time;
// consumers must handle null (= push notifications unavailable).
function initMessaging(): Messaging | null {
  const supported =
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window &&
    'indexedDB' in window;

  if (!supported) {
    return null;
  }

  try {
    return getMessaging(FirebaseApp);
  } catch {
    return null;
  }
}

export const FirebaseMessaging: Messaging | null = initMessaging();
